<template>
  <div class="gm-admin-tab">
    <server-table
      class="text-center groovemail-block-to-domains-table"
      ref="serverTable"
      :url="blockListDomainsListingUrl"
      tableRef="blacklistTable"
      :slotData="blockToDomainTableSlotData"
      :tableColumns="blacklistDomainTableColumns"
      :tableOptions="blacklistDomainTableOptions"
      tableTitle="frontend_groovemail_admin_block_to_domains"
      addNewBtnText="frontend_groovemail_admin_block_to_domains"
      uploadFileBtnText="frontend_groovemail_admin_block_to_domains_via_import"
      :buttonViaImport="blockDomainButtonViaImport"
      downloadSampleFileBtnText="frontend_groovemail_admin_block_sample_file"
      @downloadSampleFile="downloadSampleForBlacklistingDomains"
      @onFileChange="onFileChange"
      @addNewData="openBlacklistDomainsModal"
      @loaded="hideLoader()"
      @loading="showLoader()"
    >
    </server-table>

    <gs-named-modal
      id="blacklistDomainModal"
      name="blacklist-domain-modal"
      :title="this.$t('frontend_groovemail_admin_block_to_domains')"
    >
      <div class="gm-admin-modal__body">
        <gs-field :label="$t('frontend_groovemail_admin_block_to_domains')">
          <text-area
            variant="base"
            v-model="model.domains"
            :placeholder="$t('frontend_groovemail_admin_block_from_domains_enter_domains')"
            rows="5"
          />
        </gs-field>
        <p class="gm-admin-tab__note">
          <span class="fa fa-info-circle"></span>
          {{ this.$t('frontend_groovemail_admin_block_from_domains_note') }}
        </p>
        <div class="gm-admin-modal__footer">
          <gs-button variant="outline" @click="closeBlacklistDomainsModal()">{{ $t('frontend_cancel') }}</gs-button>
          <gs-button variant="primary" @click="addDomainsToBlacklist()">{{ $t('frontend_save') }}</gs-button>
        </div>
      </div>
    </gs-named-modal>

    <!-- Confirmation delete modal -->
    <confirm-modal
      :ref="`confirmation-delete-blacklisted`"
      :name="`confirmation-delete-blacklisted`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_blocked_domains_in_email_are_you_sure_delete_domains')"
      @confirm="removeBlacklistedDomain"
      @close="closeDeleteBlacklistedModal"
    />

    <!-- Confirmation import csv -->
    <confirm-modal
      :ref="`confirmation-import-csv`"
      :name="`confirmation-import-csv`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_admin_block_domains_are_you_sure')"
      @confirm="confirmFileChnage"
      @close="closeFileChnageConfirm"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import { showRequestErrorAlert } from '@/components/showDialog.js';
import { adminUrls } from '@/utils/urls.js';
import downloadCsvFile from '@/components/downloadCsvFile.js';
import { getData, postData, deleteData } from '@/utils/apiHelper.js';
import monthsMixin from '@/mixin/monthsMixin.js';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

let self;

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('frontend_groovemail_admin_block_to_domains') };
  },
  mixins: [demoModeValuesMixin, monthsMixin],
  data() {
    return {
      blockListDomainsListingUrl: adminUrls.blocklistsUrls.blockListDomains,
      fileinput: '',
      model: {
        domains: '',
      },
      confirmId: null,
      blacklistedDomains: [],
      blacklistDomainTableColumns: ['domain', 'created_at', 'actions'],
      blacklistDomainTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: ['domain'],
        sortable: ['domain', 'created_at'],
        headings: {
          domain: () => this.$t('frontend_gduikit_sidebar_product_domains'),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          actions: () => this.getDataActions(),
        },
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data[0]?.data.map((obj) => ({
              ...obj,
              domain: self.basicDomainText,
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }

          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      },

      confirmFileTarget: null,
    };
  },

  components: {
    ServerTable,
  },

  created() {
    self = this;
  },

  watch: {
    // Used to refresh black list table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.blacklistTable.refresh();
    },
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },

    /**
     * Returns column heading for total records
     * @returns {string} column heading for total records
     */
    getDataActions() {
      return this.$refs &&
        this.$refs.serverTable &&
        this.$refs.serverTable.$refs.blacklistTable &&
        this.$refs.serverTable.$refs.blacklistTable.count
        ? `${this.$t(
            'frontend_groovemail_admin_blocklists_total_records_label'
          )}: ${this.$refs.serverTable.$refs.blacklistTable.count}`
        : `${this.$t(
            'frontend_groovemail_admin_blocklists_total_records_label'
          )}: 0`;
    },

    // Downloads sample data for blacklisting to domains
    async downloadSampleForBlacklistingDomains() {
      try {
        await downloadCsvFile(
          adminUrls.blocklistsUrls.downloadSampleForBlockedFromDomains,
          null,
          'domains.csv'
        );
      } catch (error) {
        showRequestErrorAlert(error?.response?.data?.message);
      }
    },


    // open delete blacklisted modal
    async openDeleteBlacklistedModal(id) {
      // set the Confirm id
      this.confirmId = id;

      // open the modal
      this.$refs[`confirmation-delete-blacklisted`].open();
    },

    // close delete blacklisted modal
    closeDeleteBlacklistedModal() {
      // reset the Confirm id
      this.confirmId = null;
    },

    // remove blacklisted domain
    async removeBlacklistedDomain() {
      try {
        await deleteData(`${adminUrls.blocklistsUrls.blockListDomains}/${this.confirmId}`);
        const domainData = await getData(
          `${adminUrls.blocklistsUrls.blockListDomains}?query=${this.$refs.serverTable.$refs.blacklistTable.filteredQuery}&limit=${this.blacklistDomainTableOptions.perPage}&page=${this.$refs.serverTable.$refs.blacklistTable.Page}&ascending=1&byColumn=0`
        );
        this.$refs.serverTable.updateData(
          domainData?.data[0]?.data,
          domainData?.data[0]?.total
        );

      } catch (error) {
        showRequestErrorAlert(error?.response?.data?.message);
      }
    },

    // Used to upload a list of 'to' domains to blacklist in csv format.
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;

      // set the file target
      this.confirmFileTarget = files;

      if (!files.length) return;

      // open the modal
      this.$refs[`confirmation-import-csv`].open();
    },
    
    // confirm file change
    async confirmFileChnage() {
      const formData = new FormData();
      formData.append('csv', this.confirmFileTarget[0]);
      
      try {
        await postData(adminUrls.blocklistsUrls.blockListDomainsAddViaImport, formData);
      } catch (error) {
        // show error alert
        showRequestErrorAlert(error?.response?.data?.error);
      }
      
      this.$refs.serverTable.$refs.blacklistTable.refresh();

      document.getElementById('upload').value = '';
    },

    // close confirm file change
    closeFileChnageConfirm() {
      this.confirmFileTarget = null;
    },

    // Used to open blacklist domain modal to block 'to' domains.
    openBlacklistDomainsModal() {
      this.$root.$emit('modal-open', 'blacklist-domain-modal');
      this.model.domains = '';
    },

    // Used to close blacklist 'to' domain modal.
    closeBlacklistDomainsModal() {
      this.$root.$emit('modal-close', 'blacklist-domain-modal');
    },

    // Used to add 'to' domains to blacklist
    async addDomainsToBlacklist() {
      if (this.model.domains.trim()) {
        const domainData = this.model.domains.trim();
        const splitted = domainData.split('\n');
        splitted.forEach((element) => {
          if (element.trim()) {
            this.blacklistedDomains.push(element.trim().toLowerCase());
          }
        });
      }
      if (this.blacklistedDomains && this.blacklistedDomains.length) {
        this.closeBlacklistDomainsModal();
        await postData(adminUrls.blocklistsUrls.blockListDomains, {
          blacklistDomains: this.blacklistedDomains,
        });
        this.$refs.serverTable.$refs.blacklistTable.refresh();
        this.blacklistedDomains = [];
        this.model.domains = '';
      }
    },
  },

  computed: {
    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },

    // Returns styling for Import block domain button
    blockDomainButtonViaImport() {
      return {
        '--import-to-domain-text': this.$t(
          'frontend_groovemail_admin_block_to_domains_via_import'
        ),
      };
    },

    /**	
     * Returns slot data for block 'to' domains table.
     * @return {array} details for slot columns for block 'to' domains table.
    */
    blockToDomainTableSlotData() {
      return [
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_delete'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.openDeleteBlacklistedModal(props.row.id),
            },
          ],
        },
      ];
    },
  },
};
</script>


<style lang="scss">
.groovemail-block-to-domains-table #gd-server-table-view {
  .VueTables__table th:last-child {
    text-align: right;
  }

  .VueTables__table th:last-child span {
    display: inline-block;
  }
}
</style>
